module.exports = __webpack_public_path__ + "static/media/ao.8484ac5a.svg";